import { render, staticRenderFns } from "./EndOnBoard.vue?vue&type=template&id=5ba68710&scoped=true"
import script from "./EndOnBoard.vue?vue&type=script&lang=js"
export * from "./EndOnBoard.vue?vue&type=script&lang=js"
import style0 from "./EndOnBoard.vue?vue&type=style&index=0&id=5ba68710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba68710",
  null
  
)

export default component.exports